module.exports = __webpack_public_path__ + "static/media/53_B.cddac0ed.png";